import { Button } from '@/components/shared/Button';
import type { ActionNotice } from '@/types/app-state';

interface NoticeBannerProps {
  notice: ActionNotice;
  onDismiss: () => void;
}

export function NoticeBanner({ notice, onDismiss }: NoticeBannerProps): JSX.Element {
  return (
    <div className={`notice notice--${notice.kind}`}>
      <p>{notice.message}</p>
      <Button variant="ghost" onClick={onDismiss}>
        Dismiss
      </Button>
    </div>
  );
}

